import css from "./Header.module.scss";
import IconLogo from "../logo/IconLogo";

const Header = ({ innerRef }) => {
    return (
        <header className={css.header}>
            <a href="https://vsebudet.art" target="_blank" rel="noreferrer" className={css.logo}><IconLogo /></a>
            <div className={css.image}>
                <picture>
                    <source media="(min-width: 681px)" srcSet="./images/man.jpg" />
                    <img src="./images/man-small.jpg" />
                </picture>
            </div>
            <div className={css.title} onClick={ () => innerRef?.current?.scrollIntoView({ behavior: "smooth" }) }>
                <h1>Женщины — <br />ждут. <br />Мужчины — <br />выбирают</h1>
                <div className={css.subtitle}>Топ подарков для прекрасной половины Артёмовского ↓</div>
            </div>
        </header>
    )
}

export default Header;